import styled from 'styled-components';
import { AuthPanelWrapper } from '@kaseyaitglue/kaseya-ui';

export const AuthPanelWrapperStyled = styled(AuthPanelWrapper)`
  &.kaseya-ui-auth-panel-wrapper {
    height: 100%;
    overflow-y: auto;
    justify-content: flex-start;
    padding: 40px 0;

    .auth__form {
      margin-top: auto;
    }

    .auth-panel__footer {
      margin-bottom: auto;
    }

    h1 {
      text-align: center;
      margin-bottom: 16px;
    }

    .autotest-wrapper {
      display: flex;
      flex-direction: column;
    }

    .kaseya-ui-button:not(.password-field__show-button) .button-contents {
      padding: 9px 16px;
    }
  }
`;

export const SpinnerContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  height: 100%;
  width: 100%;
`;

export const ButtonGroupStyled = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;

  .kaseya-ui-form-label + & {
    margin-top: 16px;
  }

  button + button {
    margin-top: 16px;
  }
`;
